import { Link } from '@mm/components';
import { useSessionCRUDActions } from '@mm/state/actions/SessionCRUDActions';
import CompanyModel from '@mm/state/model/CompanyModel';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { monkeyImage } from '../../../../../common/constants/assets';
import { useAuthBtn } from '../use-auth-btn';
import heroImage from './hero-image.svg';
import css from './WhiteLabelLayout.module.css';
import useRouter from 'use-react-router';

type Props = {
  className?: string;
  children?: any;
  companyId?: number;
};

const useCompanyLogo = (companyId?: number) => {
  const [logoSrc, setLogoSrc] = useState('');

  const sessionCrudActions = useSessionCRUDActions();

  useEffect(() => {
    async function getCompanyLogo() {
      try {
        const { logo }: Partial<CompanyModel> =
          await sessionCrudActions.retrieveSessionCompany(companyId);
        if (logo) setLogoSrc(logo.urls.large);
        else setLogoSrc(monkeyImage);
      } catch (e) {
        setLogoSrc(monkeyImage);
      }
    }

    getCompanyLogo();
  }, []);

  return {
    logoSrc,
  };
};

export const WhiteLabelLayout = ({ className, children, companyId }: Props) => {
  const { authBtnText, authLinkDestination } = useAuthBtn();
  const {
    location: { search },
  } = useRouter();

  const authLinkDestinationWithSearch = authLinkDestination + search;

  // Note: companyId will always be present on this type
  const { logoSrc } = useCompanyLogo(companyId!);

  return (
    <div className={classNames(className, css.wrapper)}>
      <div className={css.background}>
        <div className={css.left} />
        <div className={css.right} />
      </div>

      <div className={css.container}>
        <div className={css.navbar}>
          <Link className={css.login} to={authLinkDestinationWithSearch}>
            {authBtnText}
          </Link>
        </div>

        <div className={css.content}>
          <div className={css.section}>
            <div className={css.card}>
              <div className={css.logoContainer}>
                <img src={logoSrc} alt="Logo" className={css.logo} />
              </div>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
